import makeStyles from '@material-ui/core/styles/makeStyles';

const styles = makeStyles(() => ({
  form: {},

  alignRight: {
    textAlign: 'right',
    marginTop: 32,

    '& button:first-child': {
      marginRight: 8,
    },
  },
}));

export default styles;
